export const th = {
  app: { name: 'HR', description: 'พนักงาน แผนก ตำแหน่ง การรับเข้าและพ้นสภาพ' },
  nav: {
    employees: 'พนักงาน',
    departments: 'แผนก',
    positions: 'ตำแหน่ง',
    profiles: 'ข้อมูลส่วนตัว',
    applications: 'ใบสมัครงาน',
    requests: 'คำขอ',
    invites: 'ลิงก์เชิญ',
    time: 'เวลาทำงาน',
    today: 'วันนี้',
    timesheet: 'รายเดือน',
    leaves: 'ใบลา',
    attendanceSheet: 'ตารางเวลาทำงาน',
    overtime: 'ตาราง OT',
    diligence: 'ตารางเบี้ยขยัน',
    corrections: 'ขอแก้เวลา',
    clockDisplays: 'จอลงเวลา',
    settings: 'ตั้งค่า',
    schedules: 'กะการทำงาน',
    holidays: 'วันหยุด',
    leaveTypes: 'ประเภทการลา',
    allowances: 'สิทธิ์การลา',
    export: 'ส่งออก',
  },
  opening: {
    title: 'ยกยอดเริ่มต้น',
    hint: 'เริ่มใช้ระบบกลางปี: วันลาที่ใช้ไปแล้วของปีนี้จากโปรแกรมเก่าหรือ Excel ระบบตรวจทุกแถวก่อน แล้วค่อยบันทึกทั้งหมดพร้อมกัน',
    year: 'ปี',
    kinds: { leave: 'วันลาที่ใช้ไปแล้ว' },
    kindHints: { leave: 'วันลาแต่ละประเภทที่แต่ละคนใช้ไปแล้วปีนี้ นับรวมเป็นวันที่ใช้แล้ว' },
    col: { employeeCode: 'รหัสพนักงาน', leaveTypeCode: 'ประเภทการลา (รหัสหรือชื่อ)', days: 'วันที่ใช้ไปแล้ว' },
  },
  overview: {
    title: 'ภาพรวม',
    requests: 'มีคำขอรออนุมัติ {{count}} รายการ',
    applications: 'มีใบสมัครงานรอตรวจ {{count}} ใบ',
    decisions: 'รออนุมัติ: ใบลา {{leaves}} · ขอแก้เวลา {{corrections}}',
    probation: 'ครบทดลองงานภายใน 30 วัน',
    endsOn: 'ครบ {{date}}',
    leaving: 'กำลังจะพ้นสภาพ',
    lastDay: 'วันสุดท้าย {{date}}',
    joined: 'เข้างานใน 2 สัปดาห์นี้',
    startedOn: 'เริ่ม {{date}}',
    none: 'ไม่มี',
  },
  clock: {
    title: 'ลงเวลา',
    today: 'วันนี้',
    hours: 'เวลางาน {{start}}–{{end}}',
    hoursBreak: 'เวลางาน {{start}}–{{end}} · พัก {{from}}–{{to}}',
    dayOff: 'วันนี้เป็นวันหยุด',
    onLeave: 'วันนี้ลา ({{type}})',
    scanIn: 'สแกน QR ลงเวลาเข้างาน',
    scanOut: 'สแกน QR ลงเวลาออกงาน',
    scanTitle: 'สแกน QR ลงเวลาที่สาขา',
    scanHint: 'ส่องกล้องที่ QR บนจอหน้าร้าน',
    wrongCode: 'QR นี้ไม่ใช่ QR ลงเวลา ลองอีกครั้ง',
    noCamera: 'เปิดกล้องไม่ได้ ใช้กล้องมือถือสแกน QR แทนได้',
    sending: 'กำลังลงเวลา…',
    failed: 'ลงเวลาไม่สำเร็จ',
    scanAgain: 'สแกนอีกครั้ง',
    doneIn: 'ลงเวลาเข้างาน {{time}} แล้ว',
    doneOut: 'ลงเวลาออกงาน {{time}} แล้ว',
    late: 'สาย {{minutes}} นาที',
    switchToIn: 'ไม่ใช่ เปลี่ยนเป็นเข้างาน',
    switchToOut: 'ไม่ใช่ เปลี่ยนเป็นออกงาน',
    switchHint: 'ระบบเลือกเข้าหรือออกงานให้ตามที่ลงไว้ล่าสุด เปลี่ยนได้ภายใน 10 นาที',
    clockFree: 'คุณไม่ต้องลงเวลา ทุกวันทำงานนับว่ามาทำงาน จะสแกนไว้ก็ได้',
    forgot: 'ลืมลงเวลา?',
    correction: 'ขอแก้เวลา',
    correctionHint: 'ขอย้อนหลังได้ 7 วัน หัวหน้าอนุมัติแล้วจึงนับ',
    date: 'วันที่',
    kind: 'เข้าหรือออก',
    time: 'เวลา',
    reason: 'เหตุผล',
    send: 'ส่งคำขอ',
    sent: 'ส่งคำขอแก้เวลาแล้ว รอหัวหน้าอนุมัติ',
    history: 'เวลาทำงานเดือนนี้',
    entries: 'ลงเวลาวันนี้',
    none: 'ยังไม่ได้ลงเวลา',
  },
  clockDisplay: {
    title: 'จอลงเวลา',
    plural: 'จอลงเวลา',
    create: 'เพิ่มจอลงเวลา',
    fields: {
      name: 'ชื่อจอ',
      branchId: 'สาขา',
      notes: 'หมายเหตุ',
      pairedAt: 'เชื่อมเครื่องเมื่อ',
      status: 'สถานะ',
      lastSeenAt: 'เปิดอยู่ล่าสุด',
      createdByUserId: 'สร้างโดย',
      createdAt: 'สร้างเมื่อ',
    },
    options: { status: { active: 'ใช้งาน', revoked: 'ยกเลิกแล้ว' } },
    actions: { revoke: 'ยกเลิกจอ' },
    namePlaceholder: 'เช่น มือถือหน้าร้าน',
    setup: 'บันทึกแล้วกด "{{button}}" ให้มือถือหรือแท็บเล็ตที่สาขาเป็นจอนี้ ไม่ต้องเข้าสู่ระบบบนเครื่องนั้น',
    unpaired: 'ยังไม่ได้เชื่อมเครื่อง',
    neverSeen: 'ยังไม่เคยเปิด',
    revokedHint: 'จอนี้ถูกยกเลิกแล้ว เครื่องที่เชื่อมไว้ใช้ไม่ได้ ถ้าต้องการจอใหม่ให้เพิ่มจอลงเวลาใหม่',
    pairTitle: 'เชื่อมเครื่องเป็นจอลงเวลา',
    pairHint: 'บนมือถือที่สาขา เปิด {{url}} กด "{{scan}}" แล้วส่องที่ QR นี้ หรือพิมพ์รหัสด้านล่าง',
    replaces: 'เครื่องที่เชื่อมไว้ตอนนี้จะใช้ไม่ได้',
    paired: 'เชื่อมเครื่องแล้ว',
  },
  weekday: { sun: 'อาทิตย์', mon: 'จันทร์', tue: 'อังคาร', wed: 'พุธ', thu: 'พฤหัสบดี', fri: 'ศุกร์', sat: 'เสาร์' },
  leaveType: {
    title: 'ประเภทการลา',
    plural: 'ประเภทการลา',
    create: 'เพิ่มประเภทการลา',
    fields: {
      code: 'รหัส',
      name: 'ชื่อ',
      paid: 'ได้รับค่าจ้าง',
      daysPerYear: 'วันต่อปี',
      calendarDays: 'นับวันหยุดด้วย',
      minServiceDays: 'ต้องทำงานมาแล้ว (วัน)',
      prorate: 'ปีแรกที่ได้สิทธิ์คิดตามส่วน',
      documentFromDays: 'ต้องแนบเอกสารเมื่อลาตั้งแต่ (วัน)',
      halfDay: 'ลาครึ่งวันได้',
      noticeDays: 'ต้องขอล่วงหน้า (วัน)',
      allowPast: 'ขอย้อนหลังได้',
      keepsDiligence: 'ไม่ตัดเบี้ยขยัน',
      icon: 'ไอคอน',
      color: 'สี',
      status: 'สถานะ',
      sortOrder: 'ลำดับ',
      notes: 'หมายเหตุ',
    },
    options: {
      status: { active: 'ใช้งาน', inactive: 'เลิกใช้' },
      icon: {
        calendar: 'ปฏิทิน',
        firstAid: 'กล่องปฐมพยาบาล',
        stethoscope: 'หูฟังแพทย์',
        briefcase: 'กระเป๋าเอกสาร',
        beach: 'ชายหาด',
        plane: 'เครื่องบิน',
        baby: 'รถเข็นเด็ก',
        shield: 'โล่',
        cashOff: 'ไม่รับเงิน',
        home: 'บ้าน',
        heart: 'หัวใจ',
        school: 'หมวกบัณฑิต',
        pray: 'พนมมือ',
        flower: 'ดอกไม้',
        users: 'ครอบครัว',
        cake: 'เค้ก',
      },
      color: {
        red: 'แดง',
        orange: 'ส้ม',
        amber: 'เหลืองอำพัน',
        lime: 'เขียวมะนาว',
        green: 'เขียว',
        teal: 'เขียวอมฟ้า',
        cyan: 'ฟ้า',
        blue: 'น้ำเงิน',
        indigo: 'คราม',
        violet: 'ม่วง',
        pink: 'ชมพู',
        grey: 'เทา',
      },
    },
    sections: { main: 'ประเภทการลา', rules: 'เงื่อนไข' },
    unlimited: 'ไม่จำกัด',
  },
  leaveAllowance: {
    title: 'สิทธิ์การลา',
    plural: 'สิทธิ์การลารายคน',
    create: 'ปรับสิทธิ์การลา',
    fields: {
      employeeId: 'พนักงาน',
      leaveTypeId: 'ประเภทการลา',
      year: 'ปี',
      days: 'วันลาปีนี้',
      carriedOver: 'ยกมาจากปีก่อน',
      usedBefore: 'ใช้ไปแล้วก่อนเริ่มระบบ',
      branchId: 'สาขา',
      notes: 'หมายเหตุ',
    },
    hint: 'ใส่เฉพาะคนที่ได้ไม่เท่าประเภทการลา เว้นวันลาว่างไว้เพื่อใช้ตามประเภท',
  },
  leave: {
    title: 'ใบลา',
    plural: 'ใบลา',
    create: 'บันทึกใบลา',
    fields: {
      employeeId: 'พนักงาน',
      leaveTypeId: 'ประเภทการลา',
      startDate: 'ตั้งแต่',
      endDate: 'ถึง',
      half: 'ช่วง',
      reason: 'เหตุผล',
      attachments: 'เอกสารแนบ',
      days: 'วัน',
      status: 'สถานะ',
      summary: 'ใบลา',
      userId: 'บัญชี',
      branchId: 'สาขา',
      requestedByUserId: 'บันทึกโดย',
      requestedAt: 'ขอเมื่อ',
      reviewedByUserId: 'พิจารณาโดย',
      reviewedAt: 'พิจารณาเมื่อ',
      rejectReason: 'เหตุผลที่ไม่อนุมัติ',
    },
    options: {
      half: { full: 'ทั้งวัน', morning: 'ครึ่งเช้า', afternoon: 'ครึ่งบ่าย' },
      status: { pending: 'รออนุมัติ', approved: 'อนุมัติแล้ว', rejected: 'ไม่อนุมัติ', cancelled: 'ยกเลิกแล้ว' },
    },
    actions: { approve: 'อนุมัติ', reject: 'ไม่อนุมัติ', cancel: 'ยกเลิกใบลา', print: 'พิมพ์ใบลา' },
    problems: {
      endBeforeStart: 'วันสิ้นสุดต้องไม่ก่อนวันเริ่ม',
      halfOneDay: 'ลาครึ่งวันได้ครั้งละวันเดียว',
      noHalfDay: 'ประเภทนี้ลาครึ่งวันไม่ได้',
    },
    balance: {
      title: 'วันลาคงเหลือ',
      remaining: 'เหลือ {{days}} วัน',
      of: 'ใช้ {{used}} จาก {{entitled}} วัน',
      pending: 'รออนุมัติ {{days}} วัน',
      unlimited: 'ไม่จำกัด',
      notYet: 'ยังไม่มีสิทธิ์ (ต้องทำงานครบ {{days}} วัน)',
      carried: 'ยกมา {{days}} วัน',
    },
    days: '{{count}} วัน',
    needsDocument: 'ลาตั้งแต่ {{days}} วันต้องแนบเอกสาร เช่น ใบรับรองแพทย์',
    documentNeeded: 'ต้องแนบเอกสาร เช่น ใบรับรองแพทย์',
    lockedHint: 'ใบลาที่พิจารณาแล้วแก้ไม่ได้ ถ้าต้องเปลี่ยนให้ยกเลิกแล้วบันทึกใหม่',
    approved: 'อนุมัติใบลาแล้ว',
    rejected: 'ไม่อนุมัติใบลา',
  },
  schedule: {
    title: 'กะการทำงาน',
    plural: 'กะการทำงาน',
    create: 'เพิ่มกะ',
    fields: {
      name: 'ชื่อกะ',
      startTime: 'เริ่มงาน',
      endTime: 'เลิกงาน',
      breakStart: 'เริ่มพัก',
      breakEnd: 'พักถึง',
      breakMinutes: 'พักจริง (นาที)',
      graceMinutes: 'สายได้ไม่เกิน (นาที)',
      daysOff: 'วันหยุดประจำสัปดาห์',
      holidaysNextDay: 'เลื่อนวันหยุดบริษัทไป 1 วัน',
      positionIds: 'ใช้กับตำแหน่ง',
      branchIds: 'ใช้กับสาขา',
      isDefault: 'ค่าเริ่มต้น',
      status: 'สถานะ',
      notes: 'หมายเหตุ',
    },
    options: { status: { active: 'ใช้งาน', inactive: 'เลิกใช้' } },
    sections: { main: 'เวลาทำงาน', who: 'ใช้กับใคร' },
    whoHint: 'พนักงานใช้กะของตัวเองก่อน แล้วกะตามตำแหน่ง ตามสาขา และกะเริ่มต้น',
    holidaysNextDayHint: 'สำหรับสาขาปลายทาง: วันหยุดบริษัทกะนี้ทำงานตามปกติ แล้วหยุดวันถัดไปแทน เช่น ต้นทางหยุดวันที่ 11 ปลายทางหยุดวันที่ 12',
    breakHint: 'ใส่ช่วงพัก เช่น 11:00–13:00 แล้วใส่ว่าพักจริงกี่นาที ถ้าพักตลอดช่วงเว้นว่างไว้ได้ ถ้าสลับกันพักในช่วงนั้นให้ใส่เวลาที่แต่ละคนพัก เช่น 60',
    hours: 'ทำงานปกติ {{hours}} ชม./วัน',
    hourRate: 'ค่าแรงต่อชั่วโมง (OT หักสาย) = ค่าจ้างรายวัน ÷ {{hours}}',
    members: 'พนักงานในกะนี้',
    membersHint: 'พนักงานที่เลือกไว้ใช้กะนี้ก่อนกะตามตำแหน่งหรือสาขา',
    noMembers: 'ยังไม่มีพนักงานที่เลือกกะนี้ไว้',
    add: 'เพิ่มพนักงาน',
    addPlaceholder: 'ค้นหาชื่อหรือรหัสพนักงาน',
    addButton: 'เพิ่มเข้ากะ',
    inShift: 'ตอนนี้อยู่{{shift}}',
    remove: 'เอาออกจากกะ',
    saved: 'บันทึกพนักงานในกะแล้ว',
  },
  holiday: {
    title: 'วันหยุด',
    plural: 'วันหยุดบริษัท',
    create: 'เพิ่มวันหยุด',
    fields: { date: 'วันที่', name: 'ชื่อวันหยุด', notes: 'หมายเหตุ' },
    hint: 'กฎหมายกำหนดอย่างน้อย 13 วันต่อปีรวมวันแรงงาน วันหยุดตามจันทรคติ (มาฆบูชา วิสาขบูชา อาสาฬหบูชา) ต้องเพิ่มเองทุกปี',
  },
  timeEntry: {
    title: 'บันทึกเวลา',
    plural: 'บันทึกเวลา',
    fields: {
      employeeId: 'พนักงาน',
      kind: 'เข้า/ออก',
      at: 'เวลา',
      reason: 'เหตุผล',
      date: 'วันที่',
      method: 'วิธี',
      status: 'สถานะ',
      flags: 'ข้อสังเกต',
      branchId: 'สาขาที่ลงเวลา',
      latitude: 'ละติจูด',
      longitude: 'ลองจิจูด',
      accuracy: 'ความแม่นยำ (เมตร)',
      distance: 'ห่างจากสาขา (เมตร)',
      photoFileId: 'รูปเซลฟี่',
      summary: 'รายการ',
      userId: 'บัญชี',
      homeBranchId: 'สาขาประจำ',
      recordedByUserId: 'บันทึกโดย',
      reviewedByUserId: 'พิจารณาโดย',
      reviewedAt: 'พิจารณาเมื่อ',
      rejectReason: 'เหตุผลที่ไม่อนุมัติ',
    },
    options: {
      kind: { in: 'เข้างาน', out: 'ออกงาน' },
      method: { qr: 'สแกน QR', selfie: 'เซลฟี่', recorded: 'บันทึกแทน', correction: 'ขอแก้เวลา' },
      status: { ok: 'ใช้ได้', pending: 'รออนุมัติ', rejected: 'ไม่อนุมัติ', replaced: 'ถูกแทนที่' },
      flags: { outside: 'นอกพื้นที่สาขา', noLocation: 'ไม่มีพิกัด' },
    },
    actions: { approve: 'อนุมัติ', reject: 'ไม่อนุมัติ', recordIn: 'ลงเวลาเข้าแทน', recordOut: 'ลงเวลาออกแทน', edit: 'แก้เวลา' },
    map: 'ตำแหน่งบนแผนที่',
    edit: {
      title: 'แก้เวลาของ {{name}}',
      hint: 'เวลาที่ลงไว้เดิมซึ่งต่างจากนี้จะถูกแทนที่และไม่นับ แต่ยังดูย้อนหลังได้ เว้นว่างถ้าไม่มีเวลานั้น',
      saved: 'แก้เวลาของ {{name}} แล้ว',
      fromShift: 'ลงเวลาตามกะ',
    },
  },
  overtime: {
    title: 'OT',
    plural: 'รายการ OT',
    create: 'บันทึก OT',
    fields: {
      employeeId: 'พนักงาน',
      date: 'วันที่',
      hours: 'ชั่วโมง',
      summary: 'รายการ',
      branchId: 'สาขา',
    },
    actions: { record: 'กรอกตาราง OT' },
    split: { overtime: 'OT วันทำงาน (×1.5)', holidayWork: 'ทำงานวันหยุด (×2)', holidayOvertime: 'OT วันหยุด (×3)' },
    hours: '{{hours}} ชม.',
    sheet: {
      title: 'ตาราง OT',
      period: 'งวด {{from}} – {{to}}',
      working: 'วันทำงาน ×1.5',
      off: 'วันหยุด ×2 เกินชั่วโมงปกติ ×3',
      locked: 'นับในงวดเงินเดือนแล้ว แก้ไม่ได้',
      notEmployed: 'ไม่ได้ทำงานวันนี้ (ยังไม่เริ่มงานหรือพ้นสภาพแล้ว)',
      future: 'ยังไม่ถึงวันนี้',
      own: 'OT ของตัวเองให้หัวหน้าหรือฝ่ายบุคคลกรอกให้',
      warn: 'วันนี้{{status}}',
      doubt: 'มี OT แต่วันนั้นขาด ลา หรือไม่ได้ลงเวลาออก',
      empty: 'ไม่มีพนักงานในสาขานี้ช่วงงวดนี้',
      invalid: 'ใส่ชั่วโมงทีละ 0.25 (15 นาที) ได้ไม่เกิน 24 ชั่วโมง',
    },
  },
  /** HR's sheets of a branch's people (ตาราง OT, ตารางเบี้ยขยัน) */
  sheet: { person: 'พนักงาน', drag: 'ลากเพื่อเรียงลำดับ', total: 'รวม' },
  diligence: {
    title: 'ตารางเบี้ยขยัน',
    hint: 'เดือนตามงวดเงินเดือน: ไม่ขาด ไม่ลา ไม่สาย ได้เบี้ยขยัน และได้มากขึ้นทุกเดือนที่ติดกัน',
    rates: 'อัตรา',
    none: 'ไม่ได้รับ',
    rateLabel: '{{kind}} ({{amounts}})',
    amounts: '{{amounts}} บาท ตามเดือนที่ติดกัน',
    period: 'นับวันที่ {{from}} – {{to}}',
    step: 'เดือนที่ {{step}} ติดกัน',
    top: 'ติดกัน {{steps}} เดือนขึ้นไป',
    counting: 'กำลังนับ ยังไม่ครบงวด',
    carried: 'ยกมา',
    partial: 'ไม่ได้ทำงานทั้งงวด',
    unrecorded: 'ไม่มีเวลาทำงานในระบบ',
    breaks: { absent: 'ขาด {{count}} วัน', leave: 'ลา {{count}} วัน', late: 'สาย {{count}} ครั้ง' },
    setCarried: 'เดือนนี้ได้ (ยกมาก่อนใช้ระบบ)',
    carriedHint: 'ระบบนับต่อจากเดือนถัดไป และไม่นับเดือนก่อนหน้านี้',
    clearCarried: 'ไม่ใช้ค่าที่ยกมา',
    saved: 'บันทึกเบี้ยขยันของ {{name}} แล้ว',
    yearTotal: 'ทั้งปี',
    prevYear: 'ปีก่อน',
    nextYear: 'ปีถัดไป',
    empty: 'ไม่มีพนักงานในสาขานี้',
    legend: { earned: 'ได้ (จุดบอกเดือนที่ติดกัน)', missed: 'ไม่ได้', counting: 'กำลังนับ' },
  },
  attendance: {
    title: 'เวลาทำงานวันนี้',
    month: 'ตารางเวลารายเดือน',
    export: 'ส่งออกเวลาทำงาน',
    exportHint: 'สรุปรายคนต่อเดือน: วันทำงาน มาสาย ขาด ลา และ OT สำหรับโปรแกรมเงินเดือน',
    status: {
      present: 'มาทำงาน',
      late: 'มาสาย',
      absent: 'ขาด',
      leave: 'ลา',
      off: 'หยุด',
      incomplete: 'ไม่ได้ลงเวลาออก',
      upcoming: 'ยังไม่ถึงเวลา',
    },
    lateMinutes: 'สาย {{minutes}} นาที',
    earlyMinutes: 'ออกก่อน {{minutes}} นาที',
    holiday: 'วันหยุด: {{name}}',
    dayOff: 'วันหยุดประจำสัปดาห์',
    noSchedule: 'ยังไม่มีเวลาทำงาน',
    totals: { present: 'มา', late: 'สาย', absent: 'ขาด', leave: 'ลา' },
    lateTotal: 'สาย (รวม {{minutes}} นาที)',
    totalsOf: {
      present: 'มาทำงาน {{count}} วัน',
      late: 'สาย {{count}} ครั้ง ({{minutes}} นาที)',
      absent: 'ขาด {{count}} วัน',
      leave: 'ลา {{count}} วัน',
      overtime: 'OT {{hours}} ชม.',
    },
    inAt: 'เข้า {{time}}',
    outAt: 'ออก {{time}}',
    worked: '{{hours}} ชม.',
    prevMonth: 'เดือนก่อน',
    nextMonth: 'เดือนถัดไป',
    noDays: 'ยังไม่มีข้อมูลเดือนนี้',
    noEmployee: 'ยังไม่มีข้อมูลพนักงาน ติดต่อฝ่ายบุคคล',
    flagged: 'มีข้อสังเกต',
    sheet: {
      title: 'ตารางเวลาทำงาน',
      period: 'งวด {{from}} – {{to}}',
      absent: 'ขาด',
      half: 'ครึ่งวัน',
      planned: 'เวลางาน {{start}}–{{end}}',
      noOut: 'ไม่ได้ลงเวลาออก',
      locked: 'นับในงวดเงินเดือนที่ส่งอนุมัติแล้ว แก้เวลาไม่ได้',
      lockedKey: 'นับในงวดเงินเดือนแล้ว',
      own: 'เวลาของตัวเองให้หัวหน้าหรือฝ่ายบุคคลแก้ หรือขอแก้เวลาใน My Thananan',
      edit: 'กดเพื่อแก้เวลาหรือบันทึกใบลา',
      recordLeave: 'บันทึกใบลาแทน',
      approveNow: 'อนุมัติเลย',
      leaveWaits: 'ใบลาจะรอหัวหน้าหรือฝ่ายบุคคลอนุมัติ ตารางนับวันลาเมื่ออนุมัติแล้ว',
      leaveSaved: 'บันทึกใบลาของ {{name}} แล้ว รออนุมัติ',
      leaveApproved: 'บันทึกและอนุมัติใบลาของ {{name}} แล้ว',
      leaveNotApproved: 'บันทึกใบลาของ {{name}} แล้ว แต่อนุมัติไม่ได้: {{why}}',
      cameOn: 'มา {{count}} คน',
      empty: 'ไม่มีพนักงานในสาขานี้ช่วงงวดนี้',
    },
  },
  starter: {
    button: 'ใช้ชุดเริ่มต้น',
    title: 'ชุดเริ่มต้น: {{name}}',
    add: 'เพิ่ม {{count}} รายการ',
    added: 'เพิ่ม {{count}} รายการแล้ว',
    daysOff: 'หยุด{{days}}',
    hint: {
      departments: 'แผนกของบริษัทขนส่ง เพิ่มแล้วแก้ชื่อ เพิ่ม หรือลบได้ตามจริง',
      positions: 'ตำแหน่งพร้อมบทบาทที่บัญชีใหม่ในตำแหน่งนั้นได้รับ อยู่ในแผนกที่รหัสตรงกัน (ถ้ามี) บทบาทที่คุณให้ไม่ได้จะเว้นไว้',
      schedules: 'เวลาทำงานของสำนักงาน หน้าร้าน และ DC ใช้กับตำแหน่งที่ชื่อตรงกัน (ถ้ามี) เพิ่มแล้วแก้เวลาให้ตรงกับบริษัทได้',
      holidays: 'วันหยุดราชการที่ตรงวันที่ทุกปี ของปีนี้และปีหน้า ลบวันที่บริษัทไม่หยุดได้ วันหยุดทางพุทธศาสนาและวันหยุดชดเชยเปลี่ยนทุกปี ให้เพิ่มเอง',
    },
  },
  decision: {
    approve: 'อนุมัติ',
    reject: 'ไม่อนุมัติ',
    rejectTitle: 'ไม่อนุมัติ',
    reason: 'เหตุผล',
    approved: 'อนุมัติแล้ว',
    rejected: 'ไม่อนุมัติแล้ว',
    by: '{{name}} · {{at}}',
    notYours: 'รอหัวหน้างานหรือฝ่ายบุคคลอนุมัติ',
  },
  team: {
    sheet: 'ลูกทีมของคุณ',
    sheetHint: 'คนที่มีคุณเป็นหัวหน้างาน และลูกทีมของเขาต่อลงไป',
  },
  application: {
    title: 'ใบสมัครงาน',
    plural: 'ใบสมัครงาน',
    create: 'กรอกใบสมัครแทน',
    fields: {
      title: 'คำนำหน้าชื่อ',
      name: 'ชื่อ-นามสกุล',
      nickname: 'ชื่อเล่น',
      phone: 'เบอร์โทร',
      idCard: 'เลขบัตรประชาชน',
      birthDate: 'วันเกิด',
      address: 'ที่อยู่ตามทะเบียนบ้าน',
      emergencyName: 'ผู้ติดต่อฉุกเฉิน',
      emergencyPhone: 'เบอร์ผู้ติดต่อฉุกเฉิน',
      emergencyRelation: 'ความสัมพันธ์',
      branchId: 'สาขา',
      positionId: 'ตำแหน่ง',
      startDate: 'เริ่มงานได้วันที่',
      employmentType: 'ประเภทการจ้าง',
      scheduleId: 'กะการทำงาน',
      diligence: 'อัตราเบี้ยขยัน',
      bank: 'ธนาคาร',
      bankAccount: 'เลขบัญชี',
      bankAccountName: 'ชื่อบัญชี',
      idCardFile: 'รูปบัตรประชาชน',
      photoFile: 'รูปถ่ายหน้าตรง',
      houseFile: 'รูปทะเบียนบ้าน',
      bankBookFile: 'รูปหน้าสมุดบัญชี',
      licenceFile: 'รูปใบขับขี่',
      signatureFile: 'ลายเซ็นผู้สมัคร',
      notes: 'หมายเหตุ',
      status: 'สถานะ',
      source: 'มาจาก',
      submittedAt: 'ส่งเมื่อ',
      submittedByUserId: 'ส่งโดย',
      bankChangedBy: 'แก้บัญชีธนาคารโดย',
      userId: 'บัญชีผู้ใช้',
      employeeId: 'พนักงาน',
      requestId: 'คำขอเปิดบัญชี',
      reviewedByUserId: 'ตรวจโดย',
      reviewedAt: 'ตรวจเมื่อ',
      rejectReason: 'เหตุผลที่ไม่รับ',
    },
    options: {
      status: { pending: 'รอตรวจ', approved: 'รับแล้ว', rejected: 'ไม่รับ' },
      source: { invite: 'ลิงก์เชิญ', signup: 'รหัสสาขา', lead: 'หัวหน้ากรอกให้' },
    },
    sections: { main: 'ข้อมูลส่วนตัว', contact: 'ที่อยู่และผู้ติดต่อฉุกเฉิน', work: 'งาน', bank: 'บัญชีรับเงินเดือน', documents: 'เอกสาร' },
    check: {
      title: 'ตรวจใบสมัคร',
      hint: 'ดูรูปเอกสารเทียบกับข้อมูล แก้ได้ก่อนรับ เมื่อรับแล้ว ระบบบันทึกข้อมูลพนักงานและข้อมูลส่วนตัวให้ ฝ่ายเงินเดือนเห็นเลขบัญชีตอนตั้งค่าจ้าง',
      approve: 'รับเข้าทำงาน',
      reject: 'ไม่รับ',
      rejectTitle: 'ไม่รับใบสมัครนี้',
      reason: 'เหตุผล',
      approved: 'รับแล้ว บันทึกข้อมูลพนักงานให้แล้ว',
      rejected: 'บันทึกว่าไม่รับแล้ว',
      missing: 'ยังไม่มี: {{what}}',
      noShift: 'เลือกกะการทำงานในส่วนงาน แล้วบันทึก จึงรับเข้าทำงานได้',
      unsaved: 'บันทึกการแก้ไขก่อน แล้วจึงรับเข้าทำงาน',
      usualShift: 'ตามตำแหน่งและสาขาคือ {{name}}',
      request: 'คำขอเปิดบัญชีของคนนี้ยังรออนุมัติ: อนุมัติที่หน้าคำขอเพื่อให้เข้าใช้งานได้',
      openRequest: 'ไปที่คำขอ',
      signHere: 'ถ่ายรูปลายเซ็นผู้สมัคร',
      certify: 'ข้าพเจ้าขอรับรองว่าข้อมูลและเอกสารที่ให้ไว้ในใบสมัครนี้เป็นความจริงทุกประการ',
      bankChanged: '{{name}} แก้บัญชีธนาคารจากที่ผู้สมัครกรอก ตรวจกับรูปหน้าสมุดบัญชีก่อนรับ',
      bankChangedMine: 'คุณแก้บัญชีธนาคารในใบสมัครนี้ ให้คนอื่นตรวจกับรูปหน้าสมุดบัญชีและรับเข้าทำงาน (คุณยังไม่รับได้)',
      employee: 'เปิดข้อมูลพนักงาน',
      by: '{{name}} · {{at}}',
    },
    lockedHint: 'ใบสมัครที่ตรวจแล้วแก้ไม่ได้ แก้ที่ข้อมูลพนักงานแทน',
  },
  department: {
    title: 'แผนก',
    plural: 'แผนก',
    create: 'เพิ่มแผนก',
    fields: { code: 'รหัสแผนก', name: 'ชื่อแผนก', status: 'สถานะ', notes: 'หมายเหตุ' },
    options: { status: { active: 'ใช้งาน', inactive: 'เลิกใช้' } },
  },
  position: {
    title: 'ตำแหน่ง',
    plural: 'ตำแหน่ง',
    create: 'เพิ่มตำแหน่ง',
    fields: { name: 'ชื่อตำแหน่ง', departmentId: 'แผนก', roleIds: 'บทบาทเริ่มต้น', status: 'สถานะ', notes: 'หมายเหตุ' },
    options: { status: { active: 'ใช้งาน', inactive: 'เลิกใช้' } },
    rolesHint: 'คนที่เข้าตำแหน่งนี้ได้บทบาทเหล่านี้อัตโนมัติ ไม่ต้องเลือกสิทธิ์เอง',
  },
  employee: {
    title: 'พนักงาน',
    plural: 'พนักงาน',
    create: 'เพิ่มพนักงาน',
    fields: {
      code: 'รหัสพนักงาน',
      name: 'ชื่อ-นามสกุล',
      nickname: 'ชื่อเล่น',
      photoFileId: 'รูปถ่าย',
      phone: 'เบอร์โทร',
      branchId: 'สาขา',
      departmentId: 'แผนก',
      positionId: 'ตำแหน่ง',
      managerId: 'หัวหน้างาน',
      employmentType: 'ประเภทการจ้าง',
      scheduleId: 'กะการทำงาน',
      clockFree: 'ไม่ต้องลงเวลา',
      diligence: 'อัตราเบี้ยขยัน',
      diligenceCarriedMonth: 'เบี้ยขยันยกมา: เดือน',
      diligenceCarriedStep: 'เบี้ยขยันยกมา: เดือนที่ติดกัน',
      startDate: 'วันเริ่มงาน',
      probationEndDate: 'ครบทดลองงาน',
      status: 'สถานะ',
      lastDay: 'วันทำงานวันสุดท้าย',
      leaveReason: 'เหตุผลที่ออก',
      noSeverance: 'ไม่จ่ายค่าชดเชย',
      userId: 'บัญชีผู้ใช้',
      cashOnly: 'บัญชีสำหรับถือเงิน',
      driverId: 'ข้อมูลพนักงานประจำรถ',
      notes: 'หมายเหตุ',
    },
    options: {
      employmentType: { permanent: 'พนักงานประจำ', daily: 'รายวัน', contract: 'สัญญาจ้าง' },
      status: { probation: 'ทดลองงาน', active: 'พนักงาน', resigned: 'ลาออก', terminated: 'เลิกจ้าง' },
      diligence: { inHouse: 'พักในบริษัท', outside: 'พักข้างนอก' },
    },
    sections: { main: 'ข้อมูลพนักงาน', employment: 'การจ้างงาน', other: 'อื่นๆ' },
    codeHint: 'เว้นว่างเพื่อออกรหัสถัดไปให้ (EMP-0001)',
    clockFreeHint: 'เช่น คนในสำนักงานใหญ่: ทุกวันทำงานนับว่ามา ไม่ขาด ไม่สาย ไม่หักเงิน วันลานับตามปกติ และไม่ได้เบี้ยขยัน',
    probationHint: 'เริ่มต้นเป็นวันเริ่มงาน + 119 วัน',
    noAccount: 'ยังไม่มีบัญชี',
    actions: {
      invite: 'ส่งลิงก์เข้าใช้งาน',
      offboard: 'บันทึกพ้นสภาพ',
      confirm: 'ผ่านทดลองงาน',
      holdingAccount: 'สร้างบัญชีสำหรับถือเงิน',
    },
    holding: {
      label: 'บัญชีสำหรับถือเงิน: เข้าสู่ระบบไม่ได้',
      hint: 'สำหรับคนที่ไม่ใช้แอพ: เลือกเป็นผู้รับเงินและถือเงินในระบบได้ โดยฝ่ายบัญชีบันทึกแทน ถ้าภายหลังจะใช้แอพ ให้ส่งลิงก์เข้าใช้งาน ระบบใช้บัญชีนี้ต่อ',
      created: 'สร้างบัญชีสำหรับถือเงินของ {{name}} แล้ว',
    },
    offboard: {
      section: 'การพ้นสภาพ',
      title: 'บันทึกพ้นสภาพ',
      lastDayHint: 'บัญชีถูกปิดตั้งแต่วันถัดไป',
      cashWarning: 'ยังถือเงินสดอยู่ {{amount}} บาท ต้องนำส่งหรือคืนก่อนวันสุดท้าย',
      openDocs: 'มีเอกสารเงินสดที่ยังไม่เสร็จ {{count}} รายการ',
      assets: 'ยังถือทรัพย์สินของบริษัท {{count}} รายการ ต้องรับคืนก่อนวันสุดท้าย',
      clear: 'ไม่มีเงินสดหรือทรัพย์สินค้าง',
      done: 'บันทึกแล้ว บัญชีจะปิดวันที่ {{date}}',
      noSeveranceHint: 'เลิกจ้างตามมาตรา 119 (ทุจริต ประมาทร้ายแรง ฯลฯ) หรือจ้างตามโครงการไม่เกิน 2 ปี: งวดสุดท้ายจะไม่คิดค่าชดเชย',
    },
  },
  profile: {
    title: 'ข้อมูลส่วนตัว',
    plural: 'ข้อมูลส่วนตัว',
    create: 'เพิ่มข้อมูลส่วนตัว',
    fields: {
      employeeId: 'พนักงาน',
      title: 'คำนำหน้าชื่อ',
      idCard: 'เลขบัตรประชาชน',
      birthDate: 'วันเกิด',
      address: 'ที่อยู่',
      emergencyName: 'ผู้ติดต่อฉุกเฉิน',
      emergencyPhone: 'เบอร์ผู้ติดต่อฉุกเฉิน',
      emergencyRelation: 'ความสัมพันธ์',
      documents: 'เอกสาร',
      notes: 'หมายเหตุ',
    },
    sections: { main: 'ข้อมูลส่วนตัว', emergency: 'ผู้ติดต่อฉุกเฉิน', documents: 'เอกสาร' },
    options: { title: { mr: 'นาย', mrs: 'นาง', miss: 'นางสาว' } },
    privateHint: 'เห็นได้เฉพาะฝ่ายบุคคลและเจ้าตัว',
  },
} as const

export const en = {
  app: { name: 'HR', description: 'Employees, departments, positions, joining and leaving' },
  nav: {
    employees: 'Employees',
    departments: 'Departments',
    positions: 'Positions',
    profiles: 'Personal details',
    applications: 'Job applications',
    requests: 'Requests',
    invites: 'Invite links',
    time: 'Time',
    today: 'Today',
    timesheet: 'Monthly',
    leaves: 'Leave',
    attendanceSheet: 'Attendance sheet',
    overtime: 'OT sheet',
    diligence: 'Diligence sheet',
    corrections: 'Corrections',
    clockDisplays: 'Clock screens',
    settings: 'Settings',
    schedules: 'Shifts',
    holidays: 'Holidays',
    leaveTypes: 'Leave types',
    allowances: 'Allowances',
    export: 'Export',
  },
  opening: {
    title: 'Brought forward',
    hint: "Starting mid-year: this year's leave already taken, from the old program or a spreadsheet. Every row is checked first, then all are saved together",
    year: 'Year',
    kinds: { leave: 'Leave already taken' },
    kindHints: { leave: 'Days of each kind of leave each person took this year, counted as taken' },
    col: { employeeCode: 'Employee code', leaveTypeCode: 'Leave type (code or name)', days: 'Days taken' },
  },
  overview: {
    title: 'Overview',
    requests: '{{count}} requests waiting for approval',
    applications: '{{count}} job applications to check',
    decisions: 'Waiting: {{leaves}} leave · {{corrections}} corrections',
    probation: 'Probation ending within 30 days',
    endsOn: 'Ends {{date}}',
    leaving: 'Leaving',
    lastDay: 'Last day {{date}}',
    joined: 'Joined in the last two weeks',
    startedOn: 'Started {{date}}',
    none: 'None',
  },
  clock: {
    title: 'Clock in',
    today: 'Today',
    hours: 'Hours {{start}}–{{end}}',
    hoursBreak: 'Hours {{start}}–{{end}} · break {{from}}–{{to}}',
    dayOff: 'Today is a day off',
    onLeave: 'On leave today ({{type}})',
    scanIn: 'Scan the QR to clock in',
    scanOut: 'Scan the QR to clock out',
    scanTitle: "Scan the branch's QR",
    scanHint: 'Point the camera at the QR on the counter screen',
    wrongCode: 'This is not a time-clock QR. Try again.',
    noCamera: "The camera could not start. Scan the QR with the phone's camera instead.",
    sending: 'Clocking…',
    failed: 'Could not clock',
    scanAgain: 'Scan again',
    doneIn: 'Clocked in at {{time}}',
    doneOut: 'Clocked out at {{time}}',
    late: '{{minutes}} min late',
    switchToIn: 'Not right? Make it clocking in',
    switchToOut: 'Not right? Make it clocking out',
    switchHint: 'In or out is picked from your last clocking; you can change it within 10 minutes',
    clockFree: "You don't clock in: every working day counts as come. You may still scan",
    forgot: 'Forgot to clock?',
    correction: 'Ask for a correction',
    correctionHint: 'Up to 7 days back; it counts once your lead approves',
    date: 'Date',
    kind: 'In or out',
    time: 'Time',
    reason: 'Reason',
    send: 'Send request',
    sent: 'Correction sent, waiting for your lead',
    history: 'This month',
    entries: 'Today',
    none: 'Not clocked yet',
  },
  clockDisplay: {
    title: 'Clock screen',
    plural: 'Clock screens',
    create: 'New clock screen',
    fields: {
      name: 'Screen name',
      branchId: 'Branch',
      notes: 'Notes',
      pairedAt: 'Device paired',
      status: 'Status',
      lastSeenAt: 'Last on',
      createdByUserId: 'Created by',
      createdAt: 'Created',
    },
    options: { status: { active: 'Active', revoked: 'Revoked' } },
    actions: { revoke: 'Revoke screen' },
    namePlaceholder: 'e.g. Counter phone',
    setup: 'Save, then press "{{button}}" to make a phone or tablet at the branch this screen. Nobody signs in on it.',
    unpaired: 'No device paired yet',
    neverSeen: 'Not opened yet',
    revokedHint: 'This screen is revoked and its device no longer works. For a new screen, add a new clock screen.',
    pairTitle: 'Pair a device as the clock screen',
    pairHint: 'On the phone at the branch, open {{url}}, press "{{scan}}" and point it at this QR, or type the code below',
    replaces: 'The device paired now will stop working',
    paired: 'Device paired',
  },
  weekday: { sun: 'Sunday', mon: 'Monday', tue: 'Tuesday', wed: 'Wednesday', thu: 'Thursday', fri: 'Friday', sat: 'Saturday' },
  leaveType: {
    title: 'Leave type',
    plural: 'Leave types',
    create: 'New leave type',
    fields: {
      code: 'Code',
      name: 'Name',
      paid: 'Paid',
      daysPerYear: 'Days a year',
      calendarDays: 'Counts holidays too',
      minServiceDays: 'Service needed (days)',
      prorate: 'Prorated in the first year',
      documentFromDays: 'Document needed from (days)',
      halfDay: 'Half days allowed',
      noticeDays: 'Notice (days)',
      allowPast: 'May be backdated',
      keepsDiligence: 'Keeps the diligence allowance',
      icon: 'Icon',
      color: 'Colour',
      status: 'Status',
      sortOrder: 'Order',
      notes: 'Notes',
    },
    options: {
      status: { active: 'Active', inactive: 'Not in use' },
      icon: {
        calendar: 'Calendar',
        firstAid: 'First aid kit',
        stethoscope: 'Stethoscope',
        briefcase: 'Briefcase',
        beach: 'Beach',
        plane: 'Plane',
        baby: 'Pram',
        shield: 'Shield',
        cashOff: 'No pay',
        home: 'Home',
        heart: 'Heart',
        school: 'Graduation cap',
        pray: 'Praying hands',
        flower: 'Flower',
        users: 'Family',
        cake: 'Cake',
      },
      color: {
        red: 'Red',
        orange: 'Orange',
        amber: 'Amber',
        lime: 'Lime',
        green: 'Green',
        teal: 'Teal',
        cyan: 'Sky blue',
        blue: 'Blue',
        indigo: 'Indigo',
        violet: 'Violet',
        pink: 'Pink',
        grey: 'Grey',
      },
    },
    sections: { main: 'Leave type', rules: 'Rules' },
    unlimited: 'No limit',
  },
  leaveAllowance: {
    title: 'Leave allowance',
    plural: 'Leave allowances',
    create: 'Adjust allowance',
    fields: {
      employeeId: 'Employee',
      leaveTypeId: 'Leave type',
      year: 'Year',
      days: 'Days this year',
      carriedOver: 'Carried over',
      usedBefore: 'Taken before the system',
      branchId: 'Branch',
      notes: 'Notes',
    },
    hint: "Only for people whose days differ from the leave type's; leave days empty to use the type's",
  },
  leave: {
    title: 'Leave',
    plural: 'Leave',
    create: 'Record leave',
    fields: {
      employeeId: 'Employee',
      leaveTypeId: 'Leave type',
      startDate: 'From',
      endDate: 'To',
      half: 'Part of day',
      reason: 'Reason',
      attachments: 'Attachments',
      days: 'Days',
      status: 'Status',
      summary: 'Leave',
      userId: 'Account',
      branchId: 'Branch',
      requestedByUserId: 'Recorded by',
      requestedAt: 'Requested',
      reviewedByUserId: 'Reviewed by',
      reviewedAt: 'Reviewed',
      rejectReason: 'Why not',
    },
    options: {
      half: { full: 'Whole day', morning: 'Morning', afternoon: 'Afternoon' },
      status: { pending: 'Pending', approved: 'Approved', rejected: 'Rejected', cancelled: 'Cancelled' },
    },
    actions: { approve: 'Approve', reject: 'Reject', cancel: 'Cancel leave', print: 'Print leave form' },
    problems: {
      endBeforeStart: 'The end cannot be before the start',
      halfOneDay: 'A half-day leave is one day only',
      noHalfDay: 'This leave type cannot be taken by the half day',
    },
    balance: {
      title: 'Leave left',
      remaining: '{{days}} days left',
      of: '{{used}} of {{entitled}} days used',
      pending: '{{days}} days pending',
      unlimited: 'No limit',
      notYet: 'Not yet ({{days}} days of service needed)',
      carried: '{{days}} days carried over',
    },
    days: '{{count}} days',
    needsDocument: 'From {{days}} days a document is needed, such as a medical certificate',
    documentNeeded: 'A document is needed, such as a medical certificate',
    lockedHint: 'Decided leave cannot be edited. To change it, cancel it and record it again.',
    approved: 'Leave approved',
    rejected: 'Leave rejected',
  },
  schedule: {
    title: 'Shift',
    plural: 'Shifts',
    create: 'New shift',
    fields: {
      name: 'Shift name',
      startTime: 'Start',
      endTime: 'End',
      breakStart: 'Break from',
      breakEnd: 'Break until',
      breakMinutes: 'Break taken (minutes)',
      graceMinutes: 'Late after (minutes)',
      daysOff: 'Weekly days off',
      holidaysNextDay: 'Company holidays a day later',
      positionIds: 'For positions',
      branchIds: 'For branches',
      isDefault: 'Default',
      status: 'Status',
      notes: 'Notes',
    },
    options: { status: { active: 'Active', inactive: 'Not in use' } },
    sections: { main: 'Hours', who: 'For whom' },
    whoHint: "A person's own shift first, then their position's, their branch's, then the default",
    holidaysNextDayHint:
      'For a destination branch: on a company holiday this shift works as usual and is off the next day instead (the origin off on the 11th, the destination on the 12th)',
    breakHint:
      'Give the break’s window, such as 11:00–13:00, and how long the break is: leave it empty for all of it, or put each one’s share (60) when people take it in turns',
    hours: 'A normal day is {{hours}} h',
    hourRate: 'Hourly rate (overtime, lateness) = daily wage ÷ {{hours}}',
    members: 'People on this shift',
    membersHint: 'Those chosen work this shift before their position’s or branch’s',
    noMembers: 'No one is on this shift by choice yet',
    add: 'Add people',
    addPlaceholder: 'Search a name or code',
    addButton: 'Add to the shift',
    inShift: 'Now on {{shift}}',
    remove: 'Take off the shift',
    saved: 'People on the shift saved',
  },
  holiday: {
    title: 'Holiday',
    plural: 'Company holidays',
    create: 'New holiday',
    fields: { date: 'Date', name: 'Name', notes: 'Notes' },
    hint: 'The law asks for at least 13 a year including Labour Day; lunar holidays (Makha, Visakha, Asarnha Bucha) are added each year',
  },
  timeEntry: {
    title: 'Time entry',
    plural: 'Time entries',
    fields: {
      employeeId: 'Employee',
      kind: 'In/out',
      at: 'Time',
      reason: 'Reason',
      date: 'Date',
      method: 'How',
      status: 'Status',
      flags: 'Notes',
      branchId: 'Where',
      latitude: 'Latitude',
      longitude: 'Longitude',
      accuracy: 'Accuracy (m)',
      distance: 'From the branch (m)',
      photoFileId: 'Selfie',
      summary: 'Entry',
      userId: 'Account',
      homeBranchId: 'Home branch',
      recordedByUserId: 'Recorded by',
      reviewedByUserId: 'Reviewed by',
      reviewedAt: 'Reviewed',
      rejectReason: 'Why not',
    },
    options: {
      kind: { in: 'In', out: 'Out' },
      method: { qr: 'QR scan', selfie: 'Selfie', recorded: 'Recorded for them', correction: 'Correction' },
      status: { ok: 'Counted', pending: 'Pending', rejected: 'Rejected', replaced: 'Replaced' },
      flags: { outside: 'Outside the branch', noLocation: 'No location' },
    },
    actions: { approve: 'Approve', reject: 'Reject', recordIn: 'Clock in for them', recordOut: 'Clock out for them', edit: 'Edit times' },
    map: 'On the map',
    edit: {
      title: "Edit {{name}}'s times",
      hint: 'Times recorded before that differ from these are replaced and stop counting, kept to look back on. Leave a time empty if there is none.',
      saved: "{{name}}'s times are saved",
      fromShift: 'Clock as planned',
    },
  },
  overtime: {
    title: 'Overtime',
    plural: 'Overtime',
    create: 'Record overtime',
    fields: {
      employeeId: 'Employee',
      date: 'Date',
      hours: 'Hours',
      summary: 'Entry',
      branchId: 'Branch',
    },
    actions: { record: 'Fill in the OT sheet' },
    split: { overtime: 'Overtime (×1.5)', holidayWork: 'Holiday work (×2)', holidayOvertime: 'Holiday overtime (×3)' },
    hours: '{{hours}} h',
    sheet: {
      title: 'OT sheet',
      period: 'Period {{from}} – {{to}}',
      working: 'Working day ×1.5',
      off: 'Day off ×2, past normal hours ×3',
      locked: 'Counted in a payroll run: cannot change',
      notEmployed: 'Not employed this day',
      future: 'Not yet',
      own: 'Your own OT is filled in by your lead or HR',
      warn: 'This day: {{status}}',
      doubt: 'OT on a day absent, on leave or without a clock-out',
      empty: 'Nobody works at this branch in this period',
      invalid: 'Hours go by 0.25 (15 minutes), up to 24',
    },
  },
  sheet: { person: 'Employee', drag: 'Drag to reorder', total: 'Total' },
  diligence: {
    title: 'Diligence sheet',
    hint: 'Months by payroll period: no absence, leave or lateness earns the allowance, more for each month in a row',
    rates: 'Rates',
    none: 'None',
    rateLabel: '{{kind}} ({{amounts}})',
    amounts: '{{amounts}} baht by the months in a row',
    period: 'Counts {{from}} – {{to}}',
    step: 'Month {{step}} in a row',
    top: '{{steps}} months in a row or more',
    counting: 'Still counting',
    carried: 'Carried',
    partial: 'Not employed the whole period',
    unrecorded: 'Nothing recorded',
    breaks: { absent: '{{count}} days absent', leave: '{{count}} days on leave', late: 'Late {{count}} times' },
    setCarried: 'Earned this month (before the system)',
    carriedHint: 'Counting carries on from the month after; months before it are not counted',
    clearCarried: 'Stop using the carried step',
    saved: "{{name}}'s diligence allowance is saved",
    yearTotal: 'Year',
    prevYear: 'Previous year',
    nextYear: 'Next year',
    empty: 'Nobody works at this branch',
    legend: { earned: 'Earned (dots: months in a row)', missed: 'Not earned', counting: 'Still counting' },
  },
  attendance: {
    title: "Today's attendance",
    month: 'Monthly timesheet',
    export: 'Export attendance',
    exportHint: 'Per person per month: days worked, late, absent, leave and overtime, for the payroll program',
    status: {
      present: 'Present',
      late: 'Late',
      absent: 'Absent',
      leave: 'On leave',
      off: 'Off',
      incomplete: 'No clock-out',
      upcoming: 'Not yet',
    },
    lateMinutes: '{{minutes}} min late',
    earlyMinutes: 'Left {{minutes}} min early',
    holiday: 'Holiday: {{name}}',
    dayOff: 'Weekly day off',
    noSchedule: 'No schedule yet',
    totals: { present: 'In', late: 'Late', absent: 'Absent', leave: 'Leave' },
    lateTotal: 'Late ({{minutes}} min in all)',
    totalsOf: {
      present: '{{count}} days worked',
      late: '{{count}} times late ({{minutes}} min)',
      absent: '{{count}} days absent',
      leave: '{{count}} days on leave',
      overtime: '{{hours}} h overtime',
    },
    inAt: 'In {{time}}',
    outAt: 'Out {{time}}',
    worked: '{{hours}} h',
    prevMonth: 'Previous month',
    nextMonth: 'Next month',
    noDays: 'Nothing for this month yet',
    noEmployee: 'HR has no employee record for you yet',
    flagged: 'Check',
    sheet: {
      title: 'Attendance sheet',
      period: 'Period {{from}} – {{to}}',
      absent: 'Absent',
      half: 'Half day',
      planned: 'Hours {{start}}–{{end}}',
      noOut: 'No clock-out',
      locked: 'Counted in a payroll run sent for approval: times can no longer change',
      lockedKey: 'Counted in payroll',
      own: 'Your own times are set by your lead or HR, or ask to correct them in My Thananan',
      edit: 'Click to set the times or record leave',
      recordLeave: 'Record leave for them',
      approveNow: 'Approve it now',
      leaveWaits: 'The leave waits for their lead or HR to approve it: the sheet counts it once approved',
      leaveSaved: "{{name}}'s leave is recorded and waits for approval",
      leaveApproved: "{{name}}'s leave is recorded and approved",
      leaveNotApproved: "{{name}}'s leave is recorded but could not be approved: {{why}}",
      cameOn: '{{count}} in',
      empty: 'Nobody works at this branch in this period',
    },
  },
  starter: {
    button: 'Use the starter set',
    title: 'Starter set: {{name}}',
    add: 'Add {{count}}',
    added: '{{count}} added',
    daysOff: 'off {{days}}',
    hint: {
      departments: "A transport company's departments: rename, add or remove them as yours are",
      positions:
        "Positions with the roles a new account in each gets, in the department with the same code (if there is one). Roles you can't give are left out",
      schedules: 'Office, counter and DC hours, for the positions of the same name (if there are any): change the times to yours',
      holidays:
        "This year's and next year's public holidays that fall on the same date every year: remove those you don't take. Buddhist holidays and substitute days change every year: add them yourself",
    },
  },
  decision: {
    approve: 'Approve',
    reject: 'Reject',
    rejectTitle: 'Reject',
    reason: 'Reason',
    approved: 'Approved',
    rejected: 'Rejected',
    by: '{{name}} · {{at}}',
    notYours: 'Waiting for their manager or HR',
  },
  team: {
    sheet: 'Your team',
    sheetHint: 'Those who have you as their manager, and their teams in turn',
  },
  application: {
    title: 'Job application',
    plural: 'Job applications',
    create: 'Fill in for someone',
    fields: {
      title: 'Title',
      name: 'Full name',
      nickname: 'Nickname',
      phone: 'Phone',
      idCard: 'ID card number',
      birthDate: 'Date of birth',
      address: 'Registered address',
      emergencyName: 'Emergency contact',
      emergencyPhone: 'Emergency phone',
      emergencyRelation: 'Relationship',
      branchId: 'Branch',
      positionId: 'Position',
      startDate: 'Can start on',
      employmentType: 'Employment type',
      scheduleId: 'Shift',
      diligence: 'Diligence allowance rates',
      bank: 'Bank',
      bankAccount: 'Account number',
      bankAccountName: 'Account name',
      idCardFile: 'ID card photo',
      photoFile: 'Face photo',
      houseFile: 'House registration photo',
      bankBookFile: 'Bank book photo',
      licenceFile: 'Driving licence photo',
      signatureFile: 'Applicant’s signature',
      notes: 'Notes',
      status: 'Status',
      source: 'Came by',
      submittedAt: 'Sent',
      submittedByUserId: 'Sent by',
      bankChangedBy: 'Bank account changed by',
      userId: 'Account',
      employeeId: 'Employee',
      requestId: 'Account request',
      reviewedByUserId: 'Checked by',
      reviewedAt: 'Checked',
      rejectReason: 'Why not',
    },
    options: {
      status: { pending: 'To check', approved: 'Taken on', rejected: 'Not taken' },
      source: { invite: 'Invite link', signup: 'Branch code', lead: 'Filled in by the lead' },
    },
    sections: { main: 'Personal', contact: 'Address and emergency contact', work: 'Work', bank: 'Pay account', documents: 'Documents' },
    check: {
      title: 'Check the application',
      hint: 'Check the photos against the details, correct what needs it, then take them on: their employee record and private details are written from it, and payroll sees the bank account when setting their pay',
      approve: 'Take on',
      reject: 'Not taken',
      rejectTitle: 'Not taking this application',
      reason: 'Reason',
      approved: 'Taken on: their employee record is written',
      rejected: 'Recorded as not taken',
      missing: 'Still missing: {{what}}',
      noShift: 'Pick their shift under Work and save to take them on',
      unsaved: 'Save your changes first, then take them on',
      usualShift: 'Their position and branch work {{name}}',
      request: 'Their account request still waits: approve it in the requests to let them sign in',
      openRequest: 'Open the request',
      signHere: "Photograph the applicant's signature",
      certify: 'I certify that what I give in this application, and its papers, are true',
      bankChanged: '{{name}} changed the bank account the applicant gave: check it against the bank book before taking them on',
      bankChangedMine:
        'You changed the bank account here: someone else checks it against the bank book and takes them on (you may still reject it)',
      employee: 'Open the employee',
      by: '{{name}} · {{at}}',
    },
    lockedHint: 'A checked application does not change: change the employee instead',
  },
  department: {
    title: 'Department',
    plural: 'Departments',
    create: 'New department',
    fields: { code: 'Code', name: 'Name', status: 'Status', notes: 'Notes' },
    options: { status: { active: 'Active', inactive: 'Not in use' } },
  },
  position: {
    title: 'Position',
    plural: 'Positions',
    create: 'New position',
    fields: { name: 'Name', departmentId: 'Department', roleIds: 'Default roles', status: 'Status', notes: 'Notes' },
    options: { status: { active: 'Active', inactive: 'Not in use' } },
    rolesHint: 'Whoever takes this position gets these roles; nobody picks permissions by hand',
  },
  employee: {
    title: 'Employee',
    plural: 'Employees',
    create: 'New employee',
    fields: {
      code: 'Employee code',
      name: 'Full name',
      nickname: 'Nickname',
      photoFileId: 'Photo',
      phone: 'Phone',
      branchId: 'Branch',
      departmentId: 'Department',
      positionId: 'Position',
      managerId: 'Manager',
      employmentType: 'Employment',
      scheduleId: 'Shift',
      clockFree: 'No clocking in',
      diligence: 'Diligence allowance rates',
      diligenceCarriedMonth: 'Diligence carried: month',
      diligenceCarriedStep: 'Diligence carried: months in a row',
      startDate: 'Start date',
      probationEndDate: 'Probation ends',
      status: 'Status',
      lastDay: 'Last working day',
      leaveReason: 'Reason for leaving',
      noSeverance: 'No severance',
      userId: 'Account',
      cashOnly: 'Account to hold cash',
      driverId: 'Crew record',
      notes: 'Notes',
    },
    options: {
      employmentType: { permanent: 'Permanent', daily: 'Daily', contract: 'Contract' },
      status: { probation: 'On probation', active: 'Employed', resigned: 'Resigned', terminated: 'Terminated' },
      diligence: { inHouse: "In the company's quarters", outside: 'Lives outside' },
    },
    sections: { main: 'Employee', employment: 'Employment', other: 'Other' },
    codeHint: 'Leave empty for the next code (EMP-0001)',
    clockFreeHint:
      'Such as the office at HQ: every working day counts as come, never absent or late, nothing taken off pay; leave counts as usual, and no diligence allowance',
    probationHint: 'By default the start date + 119 days',
    noAccount: 'No account yet',
    actions: {
      invite: 'Send a sign-in link',
      offboard: 'Record leaving',
      confirm: 'Passed probation',
      holdingAccount: 'Create an account to hold cash',
    },
    holding: {
      label: 'Account to hold cash: cannot sign in',
      hint: 'For someone who does not use the app: they can be picked as the one who took the money and hold cash in the system, recorded for them by accounting. If they start using the app later, send a sign-in link: it carries on with this account',
      created: 'Created an account to hold cash for {{name}}',
    },
    offboard: {
      section: 'Leaving',
      title: 'Record leaving',
      lastDayHint: 'The account closes the day after',
      cashWarning: 'Still holds {{amount}} baht in cash: to hand in or return before the last day',
      openDocs: '{{count}} cash documents not finished',
      assets: 'Still holds {{count}} of the company’s items: take them back before the last day',
      clear: 'No cash or company items outstanding',
      done: 'Saved. The account closes on {{date}}',
      noSeveranceHint:
        'Dismissed under section 119 (dishonesty, gross negligence…) or a project job of two years or less: no severance on the last payslip',
    },
  },
  profile: {
    title: 'Personal details',
    plural: 'Personal details',
    create: 'Add personal details',
    fields: {
      employeeId: 'Employee',
      title: 'Title',
      idCard: 'ID card number',
      birthDate: 'Date of birth',
      address: 'Address',
      emergencyName: 'Emergency contact',
      emergencyPhone: 'Emergency phone',
      emergencyRelation: 'Relationship',
      documents: 'Documents',
      notes: 'Notes',
    },
    sections: { main: 'Personal details', emergency: 'Emergency contact', documents: 'Documents' },
    options: { title: { mr: 'Mr', mrs: 'Mrs', miss: 'Miss' } },
    privateHint: 'Only HR and the employee see this',
  },
} as const
